<template>
<div id="contents">

  <div id="company" class="page_contents">

    <div id="company_contents">
      <div id="company_sustainability">
        <div class="page_header">
          <h1 class="page_header_title">
            <img src="../assets/img/company/title.png" width="359" alt="WORKS" />
            <span>会社について</span>
          </h1><!-- .top_sec_title -->
        </div><!-- .page_header -->

        <companyPageNav />

        <div id="company_sustainability_main" class="page_main_contents" v-bind:class="{ recruit: recruit_check() }">
          <div id="message">
            <h2 class="message_ttl">持続可能な社会に向けて<br />テレビ朝日映像として、できること</h2>
            <p class="text"><img class="img" src="../assets/img/company/sustainability/wakabayashi.png" alt="若林 邦彦" width="309"/>僕が子供のころ、スーパーマーケットには誰もが買い物かごを持って行きました。当時はレジ袋などなかったからです。豆腐を買いに行く時は鍋を持って行ったものでした。<br />時代は変わり、便利さは増し、人類が成し遂げてきたことがそのまま人類を苦しめる可能性に気づき、世界は「持続可能な社会」「SDGｓ」を目標に掲げました。<br />テレビ朝日映像はコンテンツ制作の会社です。これまでもテレビ番組、ネット配信、イベント制作などを通じて、サスティナビリティやSDGsの重要性を広く伝える番組やドキュメンタリーを作ってきました。今、私たちはそれをさらに意識し、加速させます。<br />そして、コンテンツ制作だけでなく、会社としてできる他のサスティナビリティを、持続可能な社会の実現に向けて、真剣に取り組みます。１人の社会人として、１人の生活者として、よりよい未来のために、できる限りのことをしようと思います。小さなことでも、できるものはすぐに始めたいと思います。<br />私たちは本気でSDGsの達成に向けて取り組んでいきます。</p>
            <div class="info">
              <p class="position">代表取締役社長 兼 エグゼクティブプロデューサー</p>
              <p class="name">若林 邦彦</p>
            </div>
          </div>
          <div id="begin">
            <h2 class="begin_ttl">少しずつ、始まっています</h2>
            <p class="begin_desc">映像コンテンツや番組制作をはじめとするものづくりの現場では、すでにSDGsを意識した仕事が始まっています。他にも、紙資源の見直しや研修の実施など、テレビ朝日映像ができる「サスティナビリティ」をカタチにする準備が進行中です。</p>
            <div class="program">
              <h3 class="program_ttl">映像コンテンツや番組制作</h3>
              <p class="program_desc">環境保全や社会問題などに関する映像コンテンツや番組の制作、事業展開など、サスティナビリティやSDGsに深くつながるテーマを扱う機会が増えています。たくさんの人に、まずは「伝え、関心を持ってもらう」から。</p>
              <div class="logo_list">
                <p class="item"><img src="../assets/img/company/sustainability/logo_01.png" alt="発進！ミライクリエイター" width="222"/></p>
                <p class="item"><img src="../assets/img/company/sustainability/logo_02.png" alt="人生の楽園" width="152"/></p>
                <p class="item"><img src="../assets/img/company/sustainability/logo_03.png" alt="食彩の王国" width="215"/></p>
                <p class="item"><img src="../assets/img/company/sustainability/logo_04.png" alt="ごはんジャパン" width="133"/></p>
                <p class="item"><img src="../assets/img/company/sustainability/logo_05.png" alt="環境クライシス" width="245"/></p>
              </div>
            </div>
            <div class="prep">
              <h3 class="prep_ttl">いま、始めていること</h3>
              <p class="prep_desc">日々の仕事の進め方や働き方、各社員の意識に関することまで。これまでの習慣や考えを少しずつ変えることで、<br />テレビ朝日映像全体としてサスティナブルな社会の実現に貢献していきます。</p>
              <ol class="prep_list">
                <li>
                  <div class="ttl">
                    <p class="num"><img src="../assets/img/company/sustainability/01.png" alt="01" width="42"/></p>
                    <p class="text">パートナーシップ制度の<br />導入</p>
                  </div>
                  <p class="desc anywhere">ジェンダー平等実現への取り組みとして、就業規則及び諸規程における「配偶者」の定義を改定しました。同性パートナーを配偶者に含むことで、配偶者に適用されるすべての社内制度が、同性パートナーにも法律婚の配偶者と同様に適用されることになりました。</p>
                </li>
                <li>
                  <div class="ttl">
                    <p class="num"><img src="../assets/img/company/sustainability/02.png" alt="02" width="47"/></p>
                    <p class="text">FSC認証のコピー用紙＆<br />名刺を利用</p>
                  </div>
                  <p class="desc">コピー用紙、名刺にFSC認証製品を使用しています。FSC認証の紙を使用することで、森林の適切な管理・使用に貢献できます。また、紙の使用量自体を減らすペーパーレス化に向けた取り組みも始めています。</p>
                </li>
                <li>
                  <div class="ttl">
                    <p class="num"><img src="../assets/img/company/sustainability/03.png" alt="03" width="47"/></p>
                    <p class="text">SDGs社員研修を実施</p>
                  </div>
                  <p class="desc">2021年度は、SDGsの概要や基本知識を学ぶ「基礎編」と、SDGsが映像コンテンツ制作や番組制作にどのように関わり、会社としてどう取り組むべきかを考える「実践編」を実施。<br />社員一人ひとりが自ら学び、SDGsに関わる知識獲得と意識向上に努めています。</p>
                  <p class="img center"><img src="../assets/img/company/sustainability/03_img.png" alt="SDGs社員研修" width="394"/></p>
                </li>
                <li>
                  <div class="ttl">
                    <p class="num"><img src="../assets/img/company/sustainability/04.png" alt="04" width="48"/></p>
                    <p class="text">廃棄用紙の再利用</p>
                  </div>
                  <p class="desc">シュレッダーに投棄される大量の廃棄用紙は、これまで大部分が焼却処理されてきました。ですが、この度導入されたポスト型のセキュリティBOXに入れた廃棄用紙は、機密処理施設で破砕機に投入された後、リサイクルされます。これにより、焼却処理によるCO2の排出を防ぎ、紙資源を再利用することができます。</p>
                  <p class="img center"><img src="../assets/img/company/sustainability/04_img.jpg" alt="ポスト型のセキュリティBOX" width="166"/></p>
                </li>
                <li>
                  <div class="ttl">
                    <p class="num"><img src="../assets/img/company/sustainability/05.png" alt="05" width="48"/></p>
                    <p class="text">VTRテープの<br />リサイクル活動</p>
                  </div>
                  <p class="desc">番組制作のために使用されるVTRテープは、耐用限度を超えると廃棄物となりますが、テープメーカーの協力を得て、これをリサイクルしています。再生されたプラスチック素材は建築資材などの材料として利用されています。</p>
                </li>
                <li>
                  <div class="ttl">
                    <p class="num"><img src="../assets/img/company/sustainability/06.png" alt="06" width="48"/></p>
                    <p class="text">マイボトル・マイカップの<br />推奨、こども食堂の支援</p>
                  </div>
                  <p class="desc">本社1階にマイボトル・マイカップ専用のコーヒー・紅茶自動販売機を設置しました。使い捨て紙コップの使用を減らし、廃棄物の削減を目指します。また、コーヒー、紅茶の売り上げ1杯につき30円を、全国のこども食堂を支援するNPO法人「むすびえ」に寄付します。</p>
                  <p class="img center"><img src="../assets/img/company/sustainability/06_img.png" alt="マイボトル・マイカップ専用のコーヒー・紅茶自動販売機" width="440"/></p>
                </li>
              </ol>
            </div>
          </div>
          <div id="initiative">
            <h3 class="initiative_ttl">テレビ朝日グループの取り組み</h3>
            <p class="initiative_desc">公共の電波を預かるメディア企業として、 SDGsをはじめとする社会課題の解決に積極的に取り組んでいくことは、テレビ朝日グループの重要な社会的責務の１つです。グループ全体で様々な取り組みが始まっており、今後より大きな活動にしていきます。</p>
            <div class="initiative_items">
              <div class="item">
                <h4 class="ttl">教育支援</h4>
                <p class="desc">情報学習を目的とした、学生・生徒向けの「テレビ朝日館内見学」「出前授業」や、自治体や法人に出向き生涯学習支援を行う「テレ朝出前講座」など、総合学習支援を通した社会貢献活動を行っています。</p>
              </div>
              <div class="item">
                <h4 class="ttl">社会福祉活動</h4>
                <p class="desc">1977年、民間放送局初の社会福祉法人として「テレビ朝日福祉文化事業団」を設立しました。テレビ局の特性を生かしながら、児童福祉、母子福祉、障がい者福祉、高齢者福祉など幅広い福祉活動に取り組んでいます。災害の被災者・福祉活動の援助などを目的とする「テレビ朝日ドラえもん募金」では、テレビ朝日の各番組による呼びかけを通してお寄せいただいた募金を被災地へ寄託しております。</p>
              </div>
              <div class="item">
                <h4 class="ttl">CO<span style="font-size: 20px">2</span>排出量の削減</h4>
                <p class="desc">スタジオ・オフィス照明のLED化、クールビズの実施や窓フィルムの導入に伴う冷暖房の制限、東京都条例に対応した本社の緑化など、グループをあげてCO<span style="font-size: 12px">2</span>排出量の削減に取り組んでいます。</p>
              </div>
              <div class="item">
                <h4 class="ttl">省エネ対策</h4>
                <p class="desc">電力以外にも、ガスや水などのエネルギー資源の節約も実施しています。また、2013年10月に竣工したEXタワーや2017年4月にオープンした若葉台メディアセンターでは、計画的に省エネ設備を導入しています。</p>
              </div>
            </div>
            <p class="initiative_link"><a href="https://www.tv-asahihd.co.jp/sdgs/" target="_blank">詳しくはこちら</a></p>
            <div class="sdgs">
              <h3 class="sdgs_ttl"><span>SDGsとは？</span></h3>
              <p class="sdgs_desc">2015年の国連サミットで採択された、2030年までに達成すべき「持続可能な開発目標」のことです。貧困や飢餓、エネルギー、気候変動、平和的社会など、17のグローバル目標と169のターゲットで構成されています。</p>
              <p class="sdgs_img"><img src="../assets/img/company/sustainability/sdgs.png" alt="SUSTAINABLE DEVELOPMENT GOALS" width="782"/></p>
            </div>
          </div>
        </div><!-- #company_sustainability_main -->
      </div><!-- #company_sustainability -->
    </div><!-- #company_contents -->
  </div><!-- #company -->



</div><!-- #contents -->
</template>

<script>
import companyPageNav from './shared/companyPageNav.vue'
export default {
  name: 'sustainability_index',
  components: {
    companyPageNav
  },
  mounted () {
    const ts = this
    setTimeout(function(){
      ts.$emit('page_fade')
    },ts.$parent.page_load_time)
  },
  methods: {
    recruit_check(){
      return ['recruit_2021','recruit_2022','recruit_2023','recruit_2024'].includes(this.$route.name)
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/sustainability_index.vue